"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";
import { CheckCircle2, Info, AlertTriangle, XCircle, Loader2 } from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      // This app forces dark mode at the document level; we don't rely on next-themes.
      theme={"dark"}
      className="toaster group"
      position="top-center"
      closeButton
      duration={4000}
      icons={{
        success: <CheckCircle2 className="h-5 w-5" />,
        info: <Info className="h-5 w-5" />,
        warning: <AlertTriangle className="h-5 w-5" />,
        error: <XCircle className="h-5 w-5" />,
        loading: <Loader2 className="h-5 w-5 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-black/95 group-[.toaster]:text-white group-[.toaster]:border-white/10 group-[.toaster]:shadow-lg backdrop-blur-xl",
          description: "group-[.toast]:text-white/70",
          actionButton: "group-[.toast]:bg-white/90 group-[.toast]:text-black",
          cancelButton: "group-[.toast]:bg-white/10 group-[.toast]:text-white/90",
          closeButton: "group-[.toast]:absolute group-[.toast]:top-2 group-[.toast]:right-2 group-[.toast]:bg-transparent group-[.toast]:border-0 group-[.toast]:text-white/60 hover:group-[.toast]:text-white group-[.toast]:hover:bg-transparent group-[.toast]:opacity-100",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
